// removed by extract-text-webpack-plugin
module.exports = {"spinner":"SpinnerButton__spinner___1schW","rotation":"SpinnerButton__rotation___2zQjN","spinnerButton":"SpinnerButton__spinnerButton___1iuDk","spinnerText":"SpinnerButton__spinnerText___3bq_J","spinnerElement":"SpinnerButton__spinnerElement___3sBdx","show":"SpinnerButton__show___2JVnS","spinnerButtonGray":"SpinnerButton__spinnerButtonGray___2SmCz"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/spinner-button/SpinnerButton.scss
 ** module id = 1305
 ** module chunks = 1
 **/